// #ux-redesign-start: ConfirmDialog primitive (Paso 2)
// Consolida SweetAlert + Reactstrap Modal de confirmación inline en un solo
// componente. Garantiza UX consistente (foco, esc-to-cancel, loading state).
//
// PORTABILIDAD: trasplantable a Web-Patients.
//
// USO:
//   <ConfirmDialog
//     isOpen={open}
//     title="Studie löschen?"
//     description="Diese Aktion kann nicht rückgängig gemacht werden."
//     variant="danger"
//     confirmLabel="Löschen"
//     cancelLabel="Abbrechen"
//     onConfirm={async () => { await del(); close(); }}
//     onCancel={close}
//   />
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import Button from './Button';

const ConfirmDialog = ({
  isOpen,
  title,
  description,
  variant = 'primary',
  confirmLabel = 'Bestätigen',
  cancelLabel = 'Abbrechen',
  onConfirm,
  onCancel,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await Promise.resolve(onConfirm && onConfirm());
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={submitting ? () => {} : onCancel} title={title} size="sm">
      {description && (
        <div className="ds-confirm__description">{description}</div>
      )}
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={submitting}>
          {cancelLabel}
        </Button>
        <Button variant={variant} onClick={handleConfirm} loading={submitting}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'danger']),
  confirmLabel: PropTypes.node,
  cancelLabel: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDialog;
// #ux-redesign-end
